import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import moment from 'moment';

export default function NotificationsList({
  notifications = [],
  totalPagesNotifications = 0,
  currentPageNotifications = 1,
  handlePreviousPage,
  handleNextPage,
}) {
  return (
    <div className="mt-4">
      <ul role="list">
        {notifications?.map((message) => (
          <li key={message.id}>
            <div className="relative pb-4">
              <div className="relative flex flex-col md:flex-row space-x-3 hover:bg-indigo-50 p-3 border-b border-gray-200">
                <div className="flex items-top space-x-2 md:w-1/3">
                  <span className="h-8 w-8 flex-shrink-0 rounded-full flex items-center justify-center ring-8 ring-white bg-indigo-600">
                    <BellIcon className="h-5 w-5 text-white" />
                  </span>
                  <p className="text-sm text-gray-700 uppercase flex-1">
                    {message.title}
                  </p>
                </div>

                <div className="flex-1 md:w-1/3 text-left">
                  <p className="text-sm text-gray-700">{message.message}</p>
                </div>

                <div className="flex-1 md:w-1/3 text-left md:text-right mt-2 md:mt-0">
                  <p className="text-xs text-gray-800 font-semibold text-left">Inviata a:</p>
                  {message.employees_details && Array.isArray(message.employees_details) && message.employees_details.length > 0 ? (
                    <ul className="text-xs text-gray-800">
                      {message.employees_details
                        .sort((a, b) => a.cf.localeCompare(b.cf))
                        .map((employee) => (
                          <li key={employee.id} className="flex items-center">
                            <span className="block w-1.5 h-1.5 mr-2 bg-indigo-600 rounded-full"></span>
                            {employee.last_name && employee.first_name ? (
                              <>{employee.last_name} {employee.first_name}</>
                            ) : (
                              <>{employee.cf}</>
                            )}
                          </li>
                        ))}
                    </ul>
                  ) : (
                    <p className="text-xs text-gray-800 text-left">Azienda</p>
                  )}
                  <p className="text-xs text-gray-800 font-semibold mt-1 text-left">
                    Letta da: {message.read_by}
                  </p>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>

      {/* Paginazione */}
      {notifications?.length > 0 && totalPagesNotifications > 1 && (
        <div className="flex items-center justify-between mt-4">
          <button
            onClick={handlePreviousPage}
            disabled={currentPageNotifications === 1}
            className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
              currentPageNotifications === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
            }`}
          >
            Pagina precedente
          </button>

          <div className="text-sm font-semibold text-gray-800">
            Pagina {currentPageNotifications} di {totalPagesNotifications}
          </div>

          <button
            onClick={handleNextPage}
            disabled={currentPageNotifications === totalPagesNotifications}
            className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
              currentPageNotifications === totalPagesNotifications ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
            }`}
          >
            Pagina successiva
          </button>
        </div>
      )}
    </div>
  );
}